import axios from 'axios';

export const fetchGlobalTheme = () => axios.get('../json/theme/global');